<template>
  <div>
    <!-- HEADER -->
    <form-header v-if="!createMode" :show-save-edit="true" :show-toolbox="true" :showDelete="showDelete && !readOnlyMode" :save-edit-mode="readOnlyMode"
                 :edit-enabled="editEnabled" :save-enabled="saveEnabled"
                 :delete-enabled="deleteEnabled"
        @save="save(false)"
        @edit="edit"
        @delete="deleteClick"
    >

      <!-- Left side button - primary actions -->
      <template v-slot:primaryButton>
        <slot name="primaryButton"></slot>
      </template>

      <!-- toolbars -->
      <template v-slot:toolButtons>
        <headers-button-group>
          <slot name="toolButtons"></slot>
        </headers-button-group>
      </template>

      <!-- danger actions on the right -->
      <template v-slot:dangerButton>
        <slot name="dangerButton"></slot>
      </template>

      <template v-slot:additionalHeaderRows>
        <slot name="additionalHeaderRows"></slot>
      </template>

    </form-header>
    <!-- HEADER END-->


    <v-box ref="vbox" :scrollable="true">
      <!-- CONTENT -->
        <slot>

        </slot>
      <!-- CONTENT END-->
    </v-box>

    <b-container :fluid="fluidBottomLine">
      <b-row no-gutters class="p-0 m-0">
        <slot name="bottomLine"></slot>
      </b-row>
      <b-row no-gutters class="p-0 m-0">
        <b-col>
          <div class="general-feedback">
            <label>{{ errorMessage }}&nbsp;</label>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <!-- FOOTER -->
    <footer-navbar >
      <close-button @close="close" :read-only="readOnlyMode"></close-button>
      <save-and-close-button
          v-if="!readOnlyMode"
          :enabled="saveEnabled"
          :mode="createMode ? 'NEW' : 'EDIT'"
          @save="save"
      ></save-and-close-button>
    </footer-navbar>
    <!-- FOOTER END -->
  </div>
</template>

<script>
import FormHeader from "@/components/forms/FormHeader";
import HeadersButtonGroup from "@/components/layout/HeaderButtonsGroup";
import FooterButton from "@/components/navbar/FooterButton";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import VBox from "@/components/VBox";
import CloseButton from "@/components/navbar/CloseButton";
import SaveAndCloseButton from "@/components/navbar/SaveAndCloseButton";
export default {
  name: "RecordEditActivity",
  components: {SaveAndCloseButton, CloseButton, VBox, FooterNavbar, FooterButton, HeadersButtonGroup, FormHeader},
  props: {
    showDelete: {default: true},
    unsavedChanges: {default: true},
    deleteEnabled: {default: true},
    editEnabled: {type: Boolean, default: true},
    saveEnabled: {type: Boolean, default: true},
    readOnlyMode: {default: true},
    createMode: {default: false},
    errorMessage: {type: String, default: ""},
    fluidBottomLine: {default: false}
  },
  methods: {
    close(){
      ActivityManager.closeTopActivity();
    },
    save(autoClose=true){
        this.$emit("save", autoClose);
    },
    deleteClick(){
      this.$emit("delete");
    },
    edit(){
      this.$emit("edit");
    }
  }
}
</script>

<style scoped>

</style>